import { useAccordionBlockData } from '../../../hooks/useAccordionBlockData';
import {
	getBackgroundColorClassName,
	getFontColorClassName,
} from '../../../lib/getColorClassNames';
import { Carousel } from './Carousel';
import CarouselItem from '../molecules/CarouselItem';
import { SimpleReactComponentProps } from '../../../types/components';

interface AccordionBlockProps extends SimpleReactComponentProps {
	contentLink: {
		id: string;
	};
}

export const AccordionBlock = ({
	contentLink,
	anchorId,
}: AccordionBlockProps) => {
	const data = useAccordionBlockData(contentLink.id);

	if (!data) {
		return null;
	}

	const backgroundColorClass = getBackgroundColorClassName(
		data?.backgroundColor.value || 'color-white',
	);
	const fontColorClass = getFontColorClassName(
		data?.fontColor.value || 'color-black',
	);

	return (
		<section
			className={`${backgroundColorClass} ${fontColorClass} scroll-mt-[84px]`}
			id={anchorId?.value}
		>
			<Carousel
				dataLength={data?.features.expandedValue.length}
				className={'items-center ml-0'}
			>
				{data?.features.expandedValue.map((item, index) => (
					<CarouselItem
						key={index}
						summary={item.text.value}
						imageUrl={item.image?.value?.url || ''}
						title={item.title.value}
						useImageAsHorizontal={item.useImageAsHorizontal.value}
					/>
				))}
			</Carousel>
		</section>
	);
};
